import Privettur from './privettur';

function Occupancy(parent, search) {
    Privettur.call(this, parent, search);
}

Occupancy.prototype = Object.create(Privettur.prototype);
Object.defineProperty(Occupancy.prototype, 'constructor', {
    value: Occupancy,
    enumerable: false,
    writable: true,
});

export default Occupancy;
